import { getRouteNameByMatch, RouteName } from 'common';
import { useRouteMatch } from 'react-router-dom';

export const useRouteName = (): RouteName | undefined => {
  const match = useRouteMatch();
  return getRouteNameByMatch(match);
};
